import Fetcher from '../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../constants'
import { TCheckCurrentItemListWasGeneratedResponse } from '../ContractItems/types'
import { TUploadInvoicesResponse } from './types'

const fetcher = new Fetcher({})

export const getShipToHospitalOptions = async () =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.SHIP_TO_ENTITY_HOSPITAL}`,
    method: HTTP_METHODS.GET
  })

export const uploadInvoicesFile = async (data) =>
  fetcher.request<unknown, TUploadInvoicesResponse>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.UPLOAD}`,
    method: HTTP_METHODS.POST,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })

export const checkInvoicesFileWasUploaded = async (id: string) =>
  fetcher.request<unknown, TCheckCurrentItemListWasGeneratedResponse>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.UPLOAD}${id}/`,
    method: HTTP_METHODS.GET
  })
